import { render, staticRenderFns } from "./AutomotiveNicheIcon.vue?vue&type=template&id=1a082046&scoped=true"
import script from "./AutomotiveNicheIcon.vue?vue&type=script&lang=js"
export * from "./AutomotiveNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a082046",
  null
  
)

export default component.exports